/** Suite-wide mobile UI helpers. Enabled by default; set REACT_APP_MOBILE_UI_ENABLED=false to opt out. */

export const MOBILE_BREAKPOINT_PX = 1024;

export const isMobileUiEnabled = () => {
  const raw = String(process.env.REACT_APP_MOBILE_UI_ENABLED ?? 'true').trim().toLowerCase();
  return raw !== 'false' && raw !== '0' && raw !== 'off' && raw !== 'no';
};

export const getIsMobileViewport = (breakpointPx = MOBILE_BREAKPOINT_PX) => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= breakpointPx;
};
